import * as Sentry from '@sentry/browser';

if (process.env.SENTRY_ENABLED) {
    Sentry.init({
        dsn: process.env.SENTRY_DSN_URL,
        environment: process.env.SENTRY_ENVIRONMENT
    });
}
